import { render, staticRenderFns } from "./PendingPrivateTransfers.vue?vue&type=template&id=33e6bf56&"
import script from "./PendingPrivateTransfers.vue?vue&type=script&lang=js&"
export * from "./PendingPrivateTransfers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
